import { Typography } from '@mui/material'

export const SectionTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Typography variant="subtitle2" sx={{ mb: 0.75, fontWeight: 'bold' }}>
    {children}
  </Typography>
)
